import { useBreakpoints } from '@vueuse/core'

// Sostituisce vue-mq (Vue 2). Stesse soglie Bulma usate in naviga-web.
export const breakpoints = {
  smartphone: 768,
  tablet: 1088,
  desktop: 1280,
  widescreen: 1472,
}

// Espone helper reattivi con le stesse soglie.
// Uso: const { isMobile, isTablet } = useAppBreakpoints()
export function useAppBreakpoints() {
  const bp = useBreakpoints(breakpoints)
  return {
    isMobile: bp.smaller('tablet'),
    isTablet: bp.between('tablet', 'desktop'),
    isDesktop: bp.greaterOrEqual('desktop'),
    isWidescreen: bp.greaterOrEqual('widescreen'),
    bp,
  }
}
